import { useState } from "react";
import useLenis from "../hooks/useLenis";
import Preloader from "../components/Preloader";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import LogoMarquee from "../components/LogoMarquee";
import WhoWeRepresent from "../components/WhoWeRepresent";
import Philosophy from "../components/Philosophy";
import BrandPartnerships from "../components/BrandPartnerships";
import ForTalent from "../components/ForTalent";
import ApplicationForm from "../components/ApplicationForm";
import BrandInquiry from "../components/BrandInquiry";
import Footer from "../components/Footer";

export default function Site() {
  const [ready, setReady] = useState(false);
  useLenis(ready);

  return (
    <div className="relative bg-ink" data-testid="site-root">
      <Preloader onDone={() => setReady(true)} />
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee compact label="Trusted by leading brands" className="py-12 sm:py-16 border-b border-charcoal" />
        <WhoWeRepresent />
        <Philosophy />
        <BrandPartnerships />
        <ForTalent />
        <ApplicationForm />
        <BrandInquiry />
      </main>
      <Footer />
    </div>
  );
}
